import React, { Suspense } from 'react';
import PageRouteFallback from './PageRouteFallback';

/**
 * Suspense fallback pendant le chargement lazy des pages.
 */
export default function RouteTransitionShell({ children }) {
  return (
    <div className="kio-route-shell">
      <Suspense fallback={<PageRouteFallback />}>
        {children}
      </Suspense>
    </div>
  );
}
